// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { BalancesRoutingModule } from './balances-routing.module';

// Custom packages - Components
import { AddBalanceDialogComponent } from 'src/app/modules/balances/components/add-balance-dialog/add-balance-dialog.component';
import { AddInvoiceDialogComponent } from 'src/app/modules/balances/components/add-invoice-dialog/add-invoice-dialog.component';
import { EditInvoiceDialogComponent } from 'src/app/modules/balances/components/edit-invoice-dialog/edit-invoice-dialog.component';
import { BalanceEditNoteDialogComponent } from 'src/app/modules/balances/components/edit-note-dialog/edit-note-dialog.component';
import { BalancePrintDetailDialogComponent } from 'src/app/modules/balances/components/print-detail-dialog/print-detail-dialog.component';
import { BalanceViewDetailDialogComponent } from 'src/app/modules/balances/components/view-detail-dialog/view-detail-dialog.component';
import { BalanceDetailComponent } from 'src/app/modules/balances/pages/balance-detail/balance-detail.page';
import { BalancesListClosedComponent } from 'src/app/modules/balances/pages/balances-list-closed/balances-list-closed.page';
import { BalancesListFirstComponent } from 'src/app/modules/balances/pages/balances-list-first/balances-list-first.page';
import { BalancesListFollowingComponent } from 'src/app/modules/balances/pages/balances-list-following/balances-list-following.page';
import { BalancesListComponent } from 'src/app/modules/balances/pages/balances-list/balances-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    BalancesRoutingModule,
    PublicModule,
  ],
  declarations: [
    BalancesListComponent,
    BalancesListFirstComponent,
    BalancesListFollowingComponent,
    BalancesListClosedComponent,
    BalanceDetailComponent,
    AddBalanceDialogComponent,
    AddInvoiceDialogComponent,
    EditInvoiceDialogComponent,
    BalanceEditNoteDialogComponent,
    BalanceViewDetailDialogComponent,
    BalancePrintDetailDialogComponent,
  ],
  entryComponents: [
    AddBalanceDialogComponent,
    AddInvoiceDialogComponent,
    EditInvoiceDialogComponent,
    BalanceEditNoteDialogComponent,
    BalanceViewDetailDialogComponent,
    BalancePrintDetailDialogComponent,
  ],
  exports: [
  ]
})
export class BalancesModule { }
